import * as React from 'react';
export const mergeRefs =
  (...refs) =>
  (instance) => {
    refs.forEach((ref) => {
      if ('function' == typeof ref) ref(instance);
      else if (ref) ref.current = instance;
    });
  };
export const useMergedRefs = (...refs) =>
  React.useCallback(mergeRefs(...refs), [...refs]);
